import { Model } from '@app/shared/models/model.model';

export class EmailTemplateCompiler extends Model {
  object_id: number;
  template_id?: number;
  type_id?: number;
  html_template: string;
  filters?: any;
}
